<template>
  <div class="asd20-month-select">
    <select
      id="month"
      :value="value"
      title="Month"
      name="month"
      @input="$emit('input', $event.target.value)">
      <template v-for="group in optionGroups">
        <optgroup
          :key="group.label"
          :label="group.label">
          <option
            v-for="month in group.months"
            :key="`${month} ${group.label}`"
            :value="`${month} ${group.label}`">{{ month }}</option>
      </optgroup></template>
    </select>
    <label for="month">{{ value }}</label>
  </div>
</template>

<script>
export default {
  name: 'Asd20MonthSelect',
  props: {
    value: { type: String, default: '' }
  },
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  computed: {
    optionGroups() {
      const year = new Date().getFullYear()
      const month = new Date().getMonth()
      return [year - 1, year, year+1].map(y => {
        let months = this.$options.months.map(m => m)

        return {
          label: y,
          months
        }
       })
    }
  }
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_variables.scss';

.asd20-month-select {
  flex-shrink: 0;
  position: relative;
  label {
    display: flex;
    align-items: center;
    color: asd20-swatch('primary');
    font-size: 1.2rem;
    font-weight: bold;
    border-radius: 2px;
    cursor: pointer;
    padding: space(0.5);
    text-align: center;
    justify-content: center;
    &::after {
      content: '';
      display: block;
      width: 0;
      height: 0;
      margin-left: space(0.25);
      margin-top: space(0.125);
      transform: rotate(90deg);
      border: space(0.25) solid transparent;
      border-left-color: asd20-swatch('accent-one');
      pointer-events: none;
    }
  }
  select {
    -webkit-appearance: none;
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0;
    opacity: 0;
    width: 100%;
    height: auto;
    cursor: pointer;
    &:focus ~ label {
      box-shadow: 0 0 0 5px rgba(asd20-swatch('accent-one'), 0.25) inset;
    }
  }
}

@media (min-width: 1024px) {
  .asd20-month-select {
    flex-grow: 0;
    label {
      font-size: 1.5rem;
    }
  }
}
</style>
